import React, { useCallback, useRef, useState } from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import { useNavigate } from "react-router-dom";
import Home from "../pages/Home";

const BottomNavBar = ({ onChange, values }) => {
  const navigate = useNavigate();
  const navRef = useRef(null);
  const [value, setValue] = useState(values || 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const renderScreen = useCallback(() => {
    switch (value) {
      case 0:
        return <Home />;
      case 1:
        navigate("/create");
        return null;
      case 2:
        navigate("/settings");
        return null;
      default:
        return null;
    }
  }, [value, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        position: "relative",
        top: "64px",
      }}
    >
      <Box sx={{ flexGrow: 1 }}>{renderScreen()}</Box>

      <Box sx={{ 
        width: "100%", 
        position: "fixed", 
        bottom: 0,
        height: '80px',
        boxShadow: '0px -2px 5px rgba(0,0,0,0.05)',
        zIndex: 10
      }}>
        <BottomNavigation
          ref={navRef}
          showLabels
          value={value.toString()}
          onChange={handleChange}
          sx={{ 
            backgroundColor: "#f0f0f0", 
            color: "#007bff",
            height: '80px',
            padding: '4px 0'
          }}
        >
          <BottomNavigationAction
            label="Home"
            icon={<img src="/images/navbar_home_icon.svg" alt="Home" />}
          />
          <BottomNavigationAction
            label="Create"
            icon={<img src="/images/navbar_add_icon.svg" alt="Create" />}
          />
          <BottomNavigationAction
            label="Settings"
            icon={<img src="/images/navbar_icon_setting.svg" alt="Settings" />}
          />
        </BottomNavigation>
      </Box>
    </Box>
  );
};

export default BottomNavBar;
